<template>
	<div class="outer-wrapper">
		<div class="coupon-wrapper">
			<div class="coupon-title">Have a coupon code?</div>
			<div class="coupon-input-wrapper">
				<label class="coupon-label">Code</label>
				<input
					type="text"
					:class="[
						{ couponCodeApplied: readOnlyCoupon },
						'coupon-code',
					]"
					id="coupon-code"
					placeholder="123SSAVE"
					:aria-label="
						readOnlyCoupon
							? 'Coupon code ' + couponName
							: 'Enter coupon code.'
					"
					:readonly="readOnlyCoupon"
					v-model="couponName"
					v-on:input="$emit('input', $event.target.value)"
				/>
				<button
					v-if="readOnlyCoupon"
					id="remove-coupon"
					:aria-label="'Remove coupon code ' + couponName"
					@click="removeCoupon()"
				>
					Remove
				</button>
				<button
					v-else
					id="apply-coupon"
					:aria-label="'Submit coupon code ' + couponName"
					@click="applyCoupon()"
				>
					Apply
				</button>
			</div>
		</div>
		<div v-if="error" class="error">
			<icon-base
				width="15px"
				height="15px"
				class="error-icon"
				:iconName="'Error'"
			>
				<icon-exclamation />
			</icon-base>
			<span class="error-text">{{ error }}</span>
		</div>
	</div>
</template>

<script>
import IconBase from "../IconBase.vue";
import IconExclamation from "../icons/IconExclamation.vue";
const debounce = require("lodash/debounce");

export default {
	name: "CartCoupon",
	components: {
		IconBase,
		IconExclamation
	},
	props: {
		value: {
			type: String
		},
		error: {
			type: String
		},
		isCouponApplied: {
			type: Boolean
		}
	},
	data: function() {
		return {
			couponName: this.value ? this.value : ""
		};
	},
	computed: {
		readOnlyCoupon: function() {
			if (this.isCouponApplied) {
				return true;
			}
			return false;
		}
	},
	methods: {
		removeCoupon: debounce(
			function() {
				this.$emit("remove-coupon");
				return false;
			},
			1000,
			{ leading: true, trailing: false }
		),
		applyCoupon: debounce(
			function() {
				if (this.couponName === "") {
					alert("Please enter a coupon code!");
					return false;
				}
				this.$emit("apply-coupon", this.couponName);
				return false;
			},
			1000,
			{ leading: true, trailing: false }
		)
	}
};
</script>

<style lang="scss" scoped>
.outer-wrapper {
	margin-bottom: 15px;
}

.coupon-wrapper {
	border-bottom: 1px solid $black;
	padding-bottom: 5px;
}

.coupon-title {
	font-size: 1.5rem;
	font-weight: 700;
	text-align: center;
	margin-bottom: 10px;
}

.coupon-input-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.coupon-label {
	font-size: 1.1rem;
	font-weight: 700;
	margin-right: 20px;
}

.coupon-code {
	font-size: 1.6rem;
	border: 2px solid;
	margin-right: 10px;

	&::placeholder {
		color: $placeholder_color;
	}
}
.couponCodeApplied {
	background-color: #f3f3f3;
}

.error {
	font-size: 1.4rem;
	text-align: center;
	font-weight: 700;
	color: $black;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 5px;
}

.error-icon {
	color: $tomato;
	margin-right: 5px;
}

#remove-coupon {
	background-color: $tomato;
	color: white;
	padding: 5px 25px 5px 25px;
	border-radius: 15.5px;
}

#apply-coupon {
	background-color: #0184c6;
	color: white;
	padding: 5px 25px 5px 25px;
	border-radius: 15.5px;
}
</style>